<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" type="danger"
            v-preventReClick @click="handleDelete">删除</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
           <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                  v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                  class="margin-left20 color-blue">编辑</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button type="text" class="margin-left20 color-blue"
                  v-if="system_setting.isUseRfid && tableAcl.indexOf('SetRfid') != -1"
                  @click="showRFIDDialog(scope.row)">RFID赋码</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="170" prop="no" label="备货验收单号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="100" prop="stateName" label="状态"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" width="160" prop="supplierName" label="供应商"></el-table-column>
        <el-table-column v-if="system_setting.isUseRfid" prop="packStateName" show-overflow-tooltip width="80"
          label="赋码状态"></el-table-column>
        <el-table-column width="120" prop="createdUserName" label="发起人"></el-table-column>

        <el-table-column width="170" prop="createdTime" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column width="170" prop="stockUpPlanNo" label="备货计划单号">
          <template slot-scope="scope">
            {{ scope.row.stockUpPlanNo?scope.row.stockUpPlanNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
        <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
        <el-table-column min-width="170"   prop="effectiveTime" label="生效时间">
          <template slot-scope="scope">
            <span>
              {{ scope.row.effectiveTime?parseTime(new Date(scope.row.effectiveTime),  "{y}-{m}-{d} {h}:{i}:{s}"):'-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column  label="审批人" width="100" align="center"
          prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" >
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
              @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oneLevelWarehouseName" label="收货库房" min-width="160"
          show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
              v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue">编辑</el-button>

            <el-button v-if="scope.row.status==2&&scope.row.state!=3&& scope.row.returnState == 1" type="text" v-preventReClick @click="handleRefund(scope.row)" class="color-blue">退库</el-button>

            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button type="text" class="margin-left20 color-blue"
              v-if="system_setting.isUseRfid && tableAcl.indexOf('SetRfid') != -1"
              @click="showRFIDDialog(scope.row)">RFID赋码</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  // GetDefaultWarehouse,
  GetStockUpCheckPrintData,
  GetStockUpChecks,
  RemoveStockUpCheck,
  ExportStockUpCheck,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import {
  PlanStateOptions,
  PackStateOptions,
  DistributionStateOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetStockUpChecks,
      RemoveAction: RemoveStockUpCheck,
      PrintAction: GetStockUpCheckPrintData,
      editPath: "stock-up-check-edit",
      exportAction: ExportStockUpCheck,
      PlanStateOptions: PlanStateOptions,
      PackStateOptions: PackStateOptions,
      DistributionStateOptions: DistributionStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "计划单号",
          type: "input",
          code: "stockUpPlanNo",
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商配送单号",
          type: "input",
          code: "drmStockUpDistributionNo",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "批次号",
          type: "input",
          code: "batch",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "存放库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "赋码状态",
          type: "select",
          code: "packState",
          data: PackStateOptions,
        },
        {
          name: "验收状态",
          type: "select",
          code: "state",
          data: DistributionStateOptions,
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
      ],
      
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      //   warehouseId: '',
      //   warehouseName: '',
      //   loginDeptId: this.mySessionStorage.getDeptId(),
      //   loginWarehouseId: this.mySessionStorage.getWarehouseId()
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
    };
  },
  methods: {
       handleRefund(row){
       this.routePushWithParams("/stock-up-refund-edit",{}, { formMode: 1, refundNo: row.no});
    },
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // // 打印
    // print (command) {
    //   // const length = this.ids.length
    //   // if (length !== 1) {
    //   //   this.$my_message('请选择一条数据', 'warning')
    //   //   return
    //   // }

    //   for (let i = 0; i < this.ids.length; i++) {
    //     var id = this.ids[i]
    //     this.PrintAction({ id: id, type: command })
    //       .then(res => {
    //         var result = res.returnData

    //         var printData = this.printDataConvert(result.printData)
    //         this.sendPrintMessage(JSON.stringify(printData));
    //         if (i == this.ids.length) {
    //           this.getData()
    //         }
    //       })
    //   }
    // },
    // // 获取列表
    // getData () {
    //   this.GetDatasAction(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //     // this.$nextTick(() => {
    //     //   console.log(this.$refs.multipleTable)
    //     //   this.$refs.multipleTable.doLayout()
    //     // })
    //   });
    // }, // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;

    //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       return this.RemoveAction({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
 
    // // 查看信息
    // handleInfo (row) {
    //   // this.$router.push("/" + this.editPath + "?formMode=0&id=" + row.id);
    //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 0, id: row.id });
    // },
    // // 新建
    // handleAdd () {
    //   // this.$router.push("/" + this.editPath + "?formMode=1");
    //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 1 });
    // },
    // // 编辑
    // handleUpdate (row) {
    //   // this.$router.push("/" + this.editPath + "?formMode=2&id=" + row.id);
    //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 2, id: row.id });
    // },
    // // 审批
    // handleApprove (row) {
    //   // this.$router.push("/" + this.editPath + "?formMode=3&id=" + row.id);
    //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 3, id: row.id });
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },

    // // 重置
    // reset (e) {
    //   console.log('reset')
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //     warehouseId: '',
    //     warehouseName: '',
    //     loginDeptId: this.mySessionStorage.getDeptId(),
    //     loginWarehouseId: this.mySessionStorage.getWarehouseId()
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    //   this.ids = []
    //   this.multipleSelection = []
    //   this.multiple = true;

    //   if (this.$refs.multipleTable) {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    //   this.getData();
    //   // e.preventDefault()
    // },
    // queryChange () {
    //   console.log('queryChange')
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },

    // getDefaultWarehouse () {
    //   GetDefaultWarehouse({ deptId: this.userInfo.deptId })
    //     .then(res => {
    //       if (res.successful && res.returnData.id) {
    //         // this.$set(this.query, 'warehouseId', res.returnData.id)
    //         this.query.warehouseId = res.returnData.id
    //         this.query.warehouseName = res.returnData.name
    //         this.$refs["selectFilter"].query.warehouseId = res.returnData.id
    //         this.$refs["selectFilter"].query.warehouseIdName = res.returnData.name
    //       }

    //       this.getData()
    //     })
    // },

    showRFIDDialog (row) {
      // this.$router.push("/pack-edit?category=1&id=" + row.id);
      this.routePushWithParams("/pack-edit", this.query, { category: 1, id: row.id });
    },
  },
  created () {
    // 分页组件默认值需要早created
    // if (this.$route.params) {
    //   this.query = this.$route.params
    // }
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query = this.query
    // }
    // this.getDefaultWarehouse()
  },
};
</script>

<style lang="scss" scoped></style>
